var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.75vw",
    height: "2.5vh",
    viewBox: "0 0 1 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 3.83301H5.83317C4.9127 3.83301 4.1665 4.5792 4.1665 5.49967V16.333C4.1665 17.2535 4.9127 17.9997 5.83317 17.9997H14.1665C15.087 17.9997 15.8332 17.2535 15.8332 16.333V5.49967C15.8332 4.5792 15.087 3.83301 14.1665 3.83301Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H12.5M7.5 11.3333H12.5M7.5 14.6667H10.8333",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.7cc250c4b22dd8abdf5dc3fc0e03951b.svg";
export { ForwardRef as ReactComponent };